import { signal } from '@preact/signals';
import { fetchDashboard, fetchNews } from '@/api';

export const dashboard = signal(null);
export const news = signal([]);
export const dashboardLoading = signal(false);
export const dashboardError = signal(null);

export async function loadDashboard() {
  dashboardLoading.value = true;
  dashboardError.value = null;
  try {
    const data = await fetchDashboard();
    dashboard.value = {
      ...data.partner,
      addresses: data.addresses ?? [],
      contacts: data.contacts ?? [],
    };
  } catch (err) {
    dashboardError.value = err;
  } finally {
    dashboardLoading.value = false;
  }
}

export async function loadNews() {
  try {
    const data = await fetchNews();
    news.value = data.items ?? [];
  } catch (err) {
    console.error('news load', err);
  }
}
